import Card from 'components/Card';
import InputSearchAddress from 'components/SearchAddressInput';
import { SectionTextWrapper } from 'styles/global.styles';

import React from 'react';
import styled from 'styled-components';

interface IAddressSection {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const AddressSection = (props: IAddressSection): JSX.Element => {
  return (
    <Wrapper>
      <Card>
        <SectionTextWrapper
          sectionNumber={1}
          heading="Var behöver ni hjälp med återvinning?"
          description="Fyll i er adress för att ta del av erbjudande på er ort."
        />

        <AddressInput onClick={props.onClick} />
      </Card>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 2rem;
`;

const AddressInput = styled(InputSearchAddress)`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`;

export default AddressSection;
